import React from 'react'
import { Helmet } from "react-helmet";
import './SiteMap.scss';
import AreaData from '../../Components/ServicesPage/AreaData'
import CityList from '../../Components/HomePageCity/CitiesData'

export default function SiteMap({ CitiePhone }) {
    return (
        <div className="SiteMap">
            <Helmet>
                <title>Site Map | Smith and Sons Chimney | 866-907-7220</title>
                <meta name="title" property="title" content="Site Map | Smith and Sons Chimney" data-react-helmet="true" />
                <meta name="og:title" property="og:title" content="Site Map | Smith and Sons Chimney" data-react-helmet="true" />
                <meta name="description" content="Browse every page on Smith and Sons Chimney — services, city pages, blog, contact and more." data-react-helmet="true" />
                <meta name="og:url" property="og:url" content="https://www.smithandsonschimney.com/sitemap" />
                <link rel="canonical" href="https://www.smithandsonschimney.com/sitemap" />
                <meta name="robots" content="index, follow" />
            </Helmet>

            <div className="SiteMapHero">
                <h1>Smith &amp; Sons Chimney — Site Map</h1>
                <p>A directory of every page on smithandsonschimney.com. Call <a href={`tel:${CitiePhone}`}>{CitiePhone}</a> for service.</p>
            </div>

            <div className="SiteMapGrid">
                <section className="SiteMapSection">
                    <h2>Main Pages</h2>
                    <ul>
                        <li><a href="/">Home</a></li>
                        <li><a href="/services">All Services</a></li>
                        <li><a href="/about">About Us</a></li>
                        <li><a href="/contact">Contact</a></li>
                        <li><a href="/book">Book an Appointment</a></li>
                        <li><a href="/privacy-policy">Privacy Policy</a></li>
                        <li><a href="/terms-and-conditions">Terms &amp; Conditions</a></li>
                    </ul>
                </section>

                <section className="SiteMapSection">
                    <h2>Local Landing Pages</h2>
                    <ul>
                        <li><a href="/chimney">Chimney Services</a></li>
                        <li><a href="/airduct">Air Duct Cleaning</a></li>
                        <li><a href="/dryer">Dryer Vent Cleaning</a></li>
                        <li><a href="/local">Local Service Area</a></li>
                    </ul>
                </section>

                <section className="SiteMapSection SiteMapSectionWide">
                    <h2>Services ({AreaData.length})</h2>
                    <ul className="SiteMapColumns">
                        {AreaData.map((A, i) => (
                            <li key={i}><a href={A.Path}>{A.Title}</a></li>
                        ))}
                    </ul>
                </section>

                <section className="SiteMapSection SiteMapSectionWide">
                    <h2>Service Areas ({CityList.length} cities)</h2>
                    <ul className="SiteMapColumns SiteMapColumnsCities">
                        {CityList.map((C, i) => (
                            <li key={i}><a href={`/city/${C.url}`}>{C.City}, {C.StateID}</a></li>
                        ))}
                    </ul>
                </section>
            </div>
        </div>
    )
}
